import {
  defaultNotificationSettings,
  type NotificationSettingsEntity,
} from '../../domain/entities/NotificationSettingsEntity.js';
import type { INotificationSettingsRepository } from '../../domain/repositories/INotificationSettingsRepository.js';
import type {
  NotificationSettingsDto,
  NotificationSettingsRemoteDataSource,
} from '../datasources/NotificationSettingsRemoteDataSource.js';

function toEntity(dto: NotificationSettingsDto): NotificationSettingsEntity {
  return {
    userId: dto.user_id,
    assignedTasksPush: dto.assigned_tasks_push,
    assignedIssuesPush: dto.assigned_issues_push,
    followCheckinPush: dto.follow_checkin_push,
    followCheckoutPush: dto.follow_checkout_push,
    followActivityPush: dto.follow_activity_push,
    followInactivityPush: dto.follow_inactivity_push ?? false,
    inactivityScope: dto.inactivity_scope ?? 'following',
    inactivityThresholdMinutes: dto.inactivity_threshold_minutes ?? 30,
    followOutOfGeofencePush: dto.follow_out_of_geofence_push ?? true,
    outOfGeofenceScope: dto.out_of_geofence_scope ?? 'following',
  };
}

function toDto(e: NotificationSettingsEntity): NotificationSettingsDto {
  return {
    user_id: e.userId,
    assigned_tasks_push: e.assignedTasksPush,
    assigned_issues_push: e.assignedIssuesPush,
    follow_checkin_push: e.followCheckinPush,
    follow_checkout_push: e.followCheckoutPush,
    follow_activity_push: e.followActivityPush,
    follow_inactivity_push: e.followInactivityPush,
    inactivity_scope: e.inactivityScope,
    inactivity_threshold_minutes: e.inactivityThresholdMinutes,
    follow_out_of_geofence_push: e.followOutOfGeofencePush,
    out_of_geofence_scope: e.outOfGeofenceScope,
  };
}

export class NotificationSettingsRepository implements INotificationSettingsRepository {
  constructor(private readonly remoteDataSource: NotificationSettingsRemoteDataSource) {}

  async get(userId: string): Promise<NotificationSettingsEntity> {
    const dto = await this.remoteDataSource.get(userId);
    return dto ? toEntity(dto) : defaultNotificationSettings(userId);
  }

  update(settings: NotificationSettingsEntity): Promise<void> {
    return this.remoteDataSource.upsert(toDto(settings));
  }
}
